import React from "react";
import { useVetExamContext } from "../VetExamProvider/VetExamProvider";

import JogInformationEntry from "./JogInformationEntry";
import { checkSelectingFieldsOneEntry } from "../helper";
import FormBlock from "components/FormBlock";
import { useExamLockerContext } from "components/ExamLockerContext/ExamLockerContext";
import AddEntryButton from "../AddEntryButton";
import {
  createEmptyExamJog,
  EVetExamFields,
  IExamJog,
  MAX_ENTRIES_AMOUNT
} from "../options";

const JogInformation = () => {
  const {
    values: { examJogs },
    setFieldValue
  } = useVetExamContext();
  const { lockExam } = useExamLockerContext();

  const handleCreateExamJog = async () => {
    setFieldValue(EVetExamFields.EXAM_JOGS, [
      ...examJogs,
      createEmptyExamJog()
    ]);
    lockExam();
  };

  const renderAddEntry = () => {
    if (examJogs.length < MAX_ENTRIES_AMOUNT) {
      const isDisabled = !examJogs.every(checkSelectingFieldsOneEntry);

      return (
        <AddEntryButton
          title="Add another Jog Information Entry"
          onClick={handleCreateExamJog}
          disabled={isDisabled}
        />
      );
    }
  };

  const renderEntries = () => {
    return examJogs.map((jog: IExamJog, index: number) => (
      <JogInformationEntry key={jog.id} jog={jog} entryNumber={index + 1} />
    ));
  };

  return (
    <FormBlock
      title="Jog Information"
      name={EVetExamFields.EXAM_JOGS}
      isDarkBackground={true}
      isRequired={true}
      actionsComponent={renderAddEntry()}
    >
      {renderEntries()}
    </FormBlock>
  );
};

export default JogInformation;
